import React, { useState, useEffect, useRef } from "react";
import Col from 'react-bootstrap/Col';
// import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import { CheckboxWithLabel, TextField, } from 'formik-material-ui';
import { array, object, number, string, boolean, ValidationError } from 'yup';
import { Form as RBFORM } from 'react-bootstrap';
import { IconUpload } from '@tabler/icons-react';
import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    makeStyles,
    Typography,
} from '@mui/material';
import { postMethodFormData } from "../../services/apiService";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import { getCountriesAPI, getStatesAPI, getCitiesAPI } from "../../services/placeService";
import UploadIn from '../../assets/images/icon/UploadIp.svg';
import { clearStorageAndCookies } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import { AlertDialogs } from "../dialogs/alertDialogs";
import { ToastContext, useToastContext } from "../../context/toastContext";
import PhoneInput from "react-phone-input-2";
import DeleteIcon from '../../assets/images/delete.svg';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { allTimezones  } from "react-timezone-select";
import noteIcon from '../../assets/images/noteIcon.svg';
import NoteIcon from "../icons/NoteIcon";
interface InitialValues {
    enterpriseid: string;
    name: string;
    uniqueid: string;
    email: string;
    type: string;
    addressline1: string;
    addressline2: string;
    postalcode: string;
    city: string | null;
    state: string | null;
    country: string | null;
    number: string;
    mobile: string;
    siteadminname: string,
    siteadminemail: string,
    siteadminmobile: string,
    adminprofileimage: string | null,
    submitButtonType?: string, //Optional field
    redirecturl: string,
    timezone: string,
}

export const CustomerFormStep2SiteDevice = (props: any) => {
    
    const { setToast } = useToastContext() as ToastContext;
    const navigate = useNavigate();

    const saveexitFormBtn = useRef<HTMLButtonElement | null>(null);
    const adminInputFile = useRef<HTMLInputElement | null>(null);
    const [countryList, setCountryList] = useState([]);
    const [country, setCountry] = useState("");
    const [stateList, setStateList] = useState([]);
    const [filteredStateList, setFilteredStateList] = useState([]);
    const [state, setState] = useState("");
    const [cityList, setCityList] = useState([]);
    const [filteredCityList, setFilteredCityList] = useState([]);
    const [city, setCity] = useState("");
    const [timezone, setTimezone] = useState("");
    const [adminPhotoFile, setAdminPhotoFile] = useState<string | undefined>(undefined);
    const [enterpriseId, setEnterpriseId] = useState<string | null>(null);
    const [uploadedAdminPhoto, setUploadedAdminPhoto] = useState(null);

    //const [enterpriseId, setEnterpriseId] = useState<number | undefined>(undefined);

    function getTimezoneOffset(zone: string) {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: zone,
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
        });

        const parts = formatter.formatToParts(now);
        const localHour = Number(parts.find((p) => p.type === "hour")?.value);
        const localMinute = Number(parts.find((p) => p.type === "minute")?.value);

        const utcHour = now.getUTCHours();
        const utcMinute = now.getUTCMinutes();

        const totalMinutes = (localHour * 60 + localMinute) - (utcHour * 60 + utcMinute);
        return totalMinutes;
    }

    function formatOffset(minutes: number) {
        const sign = minutes >= 0 ? "+" : "-";
        const abs = Math.abs(minutes);
        const hours = String(Math.floor(abs / 60)).padStart(2, "0");
        const mins = String(abs % 60).padStart(2, "0");
        return `UTC${sign}${hours}:${mins}`;
    }

    const timezoneList = Object.keys(allTimezones).map((zone) => {
        const offsetInMinutes = getTimezoneOffset(zone);
        const formatted = formatOffset(offsetInMinutes);

        return {
            label: `(${formatted}) ${zone}`,
            value: zone,
        };
    });

    useEffect(() => {
        getCountryList();
        getStateList();
        getCityList();
        setEnterpriseId(props.customerInfo?.enterpriseid);
        setTimezone(props.customerInfo?.timezone)
    }, []);


    const getCountryList = async () => {
        const resp = await getCountriesAPI();
        setCountryList(resp.countries);
    }


    const getStateList = async () => {
        const resp = await getStatesAPI();
        setStateList(resp.states);
    }


    const getCityList = async () => {
        const resp = await getCitiesAPI();
        setCityList(resp.cities);
    }


    const handleCountryChange = async (e: any, setFieldValue: any) => {
        const selectedCountryId = e.target.value;
        const selectedCountry = countryList.find((country: any) => country.id.toString() === selectedCountryId) || { id: '', name: '', shortname: '' };
        setCountry(selectedCountry.id === '' || selectedCountry.id === '0' ? '' : selectedCountry.name);
        setFieldValue("country", selectedCountry.id.toString());

        setTimeout(() => {
            const filteredStates = stateList.filter((state: any) => state.country_id.toString() === selectedCountry.id.toString());
            setFilteredStateList(filteredStates);
        }, 200);
    }


    const handleStateChange = async (e: any, setFieldValue: any) => {
        const selectedStateId = e.target.value;
        const selectedState = stateList.find((state: any) => state.id.toString() === selectedStateId) || { id: '', name: '', country_id: '' };
        setState(selectedState.id === '' || selectedState.id === '0' ? '' : selectedState.name);
        setFieldValue("state", selectedState.id.toString());

        setTimeout(() => {
            const filteredCities = cityList.filter((city: any) => city.state_id.toString() === selectedState.id.toString());
            setFilteredCityList(filteredCities);
        }, 200);
    }


    const handleCityChange = async (e: any, setFieldValue: any) => {
        const selectedCityId = e.target.value;
        const selectedCity = cityList.find((country: any) => country.id.toString() === selectedCityId) || { id: '', name: '', state_id: '' };
        setCity(selectedCity.id === '' || selectedCity.id === '0' ? '' : selectedCity.name);
        setFieldValue("city", selectedCity.id.toString());
    }

    const handleTimeZoneChange = async (e: any, setFieldValue: any) => {
      
        setTimezone(e.target.value);
        setFieldValue("timezone", e.target.value);
    }


    const previewImage = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
        if (e.target.files && e.target.files[0]) {
            const fileUrl = URL.createObjectURL(e.target.files[0]);
            setAdminPhotoFile(fileUrl);
        }
    }


    const handleInputFile = () => {
        if (adminInputFile?.current) {
            adminInputFile!.current.click();
        }
    }


    /********************************* AlertDialogs Controls **************************************/
    const [open, setOpen] = React.useState(false);

    const handleCancel = async (e: any) => {
        setOpen(true);
    }

    const getConfirmResponse = (action: string) => {
        if (action === 'Yes, Cancel') {
            navigate('/customer/overview');
        } else if (action === 'Save & Exit') {
            saveexitFormBtn.current?.click();
        }
    }


    useEffect(() => {
        if (enterpriseId) {
            setInitialValues(prvData => ({
                ...prvData,
                enterpriseid: enterpriseId || '',
                timezone: timezone
            }));
        }
    }, [enterpriseId]);

    const [initialValues, setInitialValues] = useState<InitialValues>({
        enterpriseid: enterpriseId || '',
        name: '',
        uniqueid: '',
        email: '',
        type: 'EDGE',
        addressline1: '',
        addressline2: '',
        postalcode: '',
        city: '',
        state: '',
        country: '',
        number: '',
        mobile: '',
        siteadminname: '',
        siteadminemail: '',
        siteadminmobile: '',
        adminprofileimage: '',
        redirecturl: '/auth/set-password?uk=',
        timezone: timezone,
    })

    /* const initialValues: InitialValues = {
        enterpriseid: props.siteInfo?.enterpriseid || enterpriseId,
        name: props.siteInfo?.name || '',
        uniqueid: props.siteInfo?.uniqueid || '',
        email: props.siteInfo?.email || '',
        addressline1: props.siteInfo?.addressline1 || '',
        addressline2: props.siteInfo?.addressline2 || '',
        postalcode: props.siteInfo?.postalcode || '',
        city: props.siteInfo?.city || '',
        state: props.siteInfo?.state || '',
        country: props.siteInfo?.country || '',
        number: props.siteInfo?.number || '',
        mobile: props.siteInfo?.mobile || '',
        siteadminname: props.siteInfo?.siteadminname || '',
        siteadminemail: props.siteInfo?.siteadminemail || '',
        siteadminmobile: props.siteInfo?.siteadminmobile || '',
        adminprofileimage: props.siteInfo?.adminprofileimage || '',
    }; */



    useEffect(() => {
        if (props.siteFormValues != null) {
            //const sess_customer_info = localStorage.getItem("sess_customer_info");
            //if (sess_customer_info && sess_customer_info != null && sess_customer_info !== undefined) {
            //const customer_info = JSON.parse(sess_customer_info);

            setCountryList(props.siteFormValues.countryList);
            setFilteredStateList(props.siteFormValues.filteredStateList);
            setFilteredCityList(props.siteFormValues.filteredCityList);
            setCountry(props.siteFormValues.countryName || "");
            setState(props.siteFormValues.stateName || "");
            setCity(props.siteFormValues.cityName || "");
            setInitialValues(prvData => ({
                ...prvData,
                name: props.siteFormValues.name,
                uniqueid: props.siteFormValues.uniqueid,
                email: props.siteFormValues.email,
                type: props.siteFormValues.type || prvData.type || 'EDGE',
                addressline1: props.siteFormValues.addressline1,
                addressline2: props.siteFormValues.addressline2,
                postalcode: props.siteFormValues.postalcode,
                city: props.siteFormValues.city,
                state: props.siteFormValues.state,
                country: props.siteFormValues.country,
                number: props.siteFormValues.number,
                mobile: props.siteFormValues.mobile,
                siteadminname: props.siteFormValues.siteadminname,
                siteadminemail: props.siteFormValues.siteadminemail,
                siteadminmobile: props.siteFormValues.siteadminmobile,
                //adminprofileimage: props.siteFormValues.adminprofileimage,
                adminprofileimage: uploadedAdminPhoto,
                timezone: props.siteFormValues.timezone
            }));

            setAdminPhotoFile(props.siteFormValues.adminprofileimage);
            //}
        }
    }, [props.siteFormValues]);


    const phoneRegex = /^\+?\d{10,15}$/;
    const removePhoto = async (name: string, setFieldValue: any) => {
        if (name === "adminprofileimage") {
            setAdminPhotoFile(undefined);
            setFieldValue("adminprofileimage", undefined);
            setUploadedAdminPhoto(null);
        }
    }


    const [profileImageError, setProfileImageError] = useState("");
    const handleImageChange = (event: any, name: string, setFieldValue: any, setFieldTouched: any) => {
        const file = event.currentTarget.files[0];

        if (!file) {
            setProfileImageError("Customer logo is required!");
            setAdminPhotoFile(undefined);
            setFieldValue("adminprofileimage", "");
            return;
        }

        // Check file type
        const validTypes = ["image/jpeg", "image/png"];
        if (!validTypes.includes(file.type)) {
            setFieldValue("adminprofileimage", "");
            setProfileImageError("Only JPG, and PNG image is allowed!");
            setAdminPhotoFile(undefined);
            return;
        }

        // Check file size (should not exceed 500KB)
        const maxSize = 500 * 1024; // 500KB in bytes
        if (file.size > maxSize) {
            setProfileImageError("Image size should not exceed 500KB!");
            setAdminPhotoFile(undefined);
            setFieldValue("adminprofileimage", "");
            return;
        }

        setAdminPhotoFile(file);
        setUploadedAdminPhoto(file);
        setFieldValue("adminprofileimage", file);
        setFieldTouched("adminprofileimage", true, false);
        previewImage(event, "adminprofileimage");
        setProfileImageError(""); // Clear error if image is valid

        // Reset the file input to allow re-uploading the same file
        event.target.value = "";
    };


    const [siteMobileNumber, setSiteMobileNumber] = useState("");
    const [adminMobileNumber, setAdminMobileNumber] = useState("");
    const validateMobileNumber = async (mobile_number: any, type: string) => {
        if(!mobile_number) {
            if(type === "site") setSiteMobileNumber("");
            else if(type === "admin") setAdminMobileNumber("");
            return;
        } 

        if (mobile_number && !mobile_number.includes('+')) {
            mobile_number = `+${mobile_number}`;
        }

        const isValid = isValidPhoneNumber(mobile_number);

        if(!isValid) {
            if(type === "site") setSiteMobileNumber("Enter a valid mobile number!");
            if(type === "admin") setAdminMobileNumber("Enter a valid mobile number!");
        } else {
            if(type === "site") setSiteMobileNumber("");
            if(type === "admin") setAdminMobileNumber("");
        }
    }


    return (
        <Formik initialValues={initialValues}
            enableReinitialize={true} // Enable reinitialization
            validationSchema={object({
                enterpriseid: number().required(""),
                name: string().trim().required("Site / Device name is required!"),
                uniqueid: string().trim().required("Unique ID is required!"),
                email: string().email().required("Email ID is required!"),
                // email: string().email().optional(),
                type: string().required("Type is required!"),
                //mobile: string().trim().optional().matches(phoneRegex, 'Enter a valid phone number'),
                addressline1: string().trim().optional(),
                addressline2: string().trim().optional(),
                postalcode: string().trim().optional(),
                city: string().trim().optional(),
                state: string().trim().optional(),
                country: string().trim().optional(),
                siteadminname: string().trim().optional(),
                siteadminemail: string().email().trim().optional(),
                //siteadminmobile: string().trim().optional().matches(phoneRegex, 'Enter a valid phone number'),
                number: string().trim().matches(/^\d{2,10}$/, "Number must be between 2 to 10 digits").optional(),
                timezone: string().trim().optional(),
            })}

            onSubmit={async (values, { setSubmitting }) => {
                if(siteMobileNumber || adminMobileNumber) {
                    return;
                }
                const submitButtonType = values.submitButtonType;
                if (values.mobile && !values.mobile.includes('+')) {
                    values.mobile = `+${values.mobile}`;
                }
                if (values.siteadminmobile && !values.siteadminmobile.includes('+')) {
                    values.siteadminmobile = `+${values.siteadminmobile}`;
                }
                delete values['submitButtonType'];

                let siteFormValues: any = { ...values };
                siteFormValues['adminprofileimage'] = adminPhotoFile;

                
                siteFormValues['countryList'] = countryList;
                siteFormValues['filteredStateList'] = filteredStateList;
                siteFormValues['filteredCityList'] = filteredCityList;
                siteFormValues['countryName'] = country;
                siteFormValues['stateName'] = state;
                siteFormValues['cityName'] = city;
               
                
                props.setSiteFormValues(siteFormValues);

                let tmpFormValues: any = { ...values };
                tmpFormValues.country = country;
                tmpFormValues.state = state;
                tmpFormValues.city = city;
                tmpFormValues.timezone = timezone;
                //tmpFormValues.redirectUrl = "/auth/set-password?uk=";
                //props.setActiveStep(2);

                if (!values.adminprofileimage) { 
                    delete tmpFormValues.adminprofileimage; 
                }

                if (props.siteInfo) {
                    if (submitButtonType === "save&exit") {
                        navigate("/customer/overview");
                    } else {
                        props.setActiveStep(2);
                    }
                } else {
                    const resp = await postMethodFormData("customer/site", tmpFormValues);
                    if (resp?.status === 200) {
                        setToast(resp?.data?.message, "success");
                        if (submitButtonType === "next") {
                            props.setSiteInfo(resp?.data?.result?.[0]);
                            props.setActiveStep(2);
                        } else if (submitButtonType === "save&exit") {
                            navigate("/customer/overview");
                        }
                    } else {
                        setToast(resp?.data?.message, "error");
                    }
                }
            }}
        >

            {({ values, errors, isSubmitting, isValid, setFieldValue, touched, setFieldTouched }) => (
                <React.Fragment>
                    <ToastContainer />
                    {/* {JSON.stringify(values, null, 2)} */}
                    <Form autoComplete="off" method="post">
                        <Row className="mb-3">
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Site / Device Name <span className="start_required">*</span></RBFORM.Label>
                                        <Field
                                            name="name"
                                            type="text"
                                            placeholder="Site / Device Name"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: props?.siteInfo,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Unique ID <span className="start_required">*</span></RBFORM.Label>
                                        <Field
                                            name="uniqueid"
                                            type="text"
                                            placeholder="Unique ID"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: props?.siteInfo,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>                                

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Type <span className="start_required">*</span></RBFORM.Label>
                                        <Field
                                            name="type"
                                            as="select"
                                            placeholder="type"
                                            className="inputC custDropdown"
                                            disabled={props?.siteInfo}
                                        >
                                            <option value="EDGE">EDGE</option>
                                            <option value="CLOUD">CLOUD</option>
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Email ID <span className="start_required">*</span></RBFORM.Label>
                                        <Field
                                            name="email"
                                            type="text"
                                            placeholder="Email ID"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: props?.siteInfo,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                            </Grid>
                        </Row>

                        <Row className="mb-3">
                            <Grid container columnSpacing={3} rowSpacing={0}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Address Line 1</RBFORM.Label>
                                        <Field
                                            name="addressline1"
                                            type="text"
                                            placeholder="Address Line 1"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: props?.siteInfo,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Address Line 2</RBFORM.Label>
                                        <Field
                                            name="addressline2"
                                            type="text"
                                            placeholder="Address Line 2"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: props?.siteInfo,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Country</RBFORM.Label>
                                        <Field
                                            name="country"
                                            as="select"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleCountryChange(e, setFieldValue)}
                                            disabled={props?.siteInfo}
                                        >
                                            <option>Select Country</option>
                                            {countryList?.length > 0 && (
                                                countryList.filter((country: any) => country.id !== "0" && country.id !== 0).map((country: any) => (
                                                    <option key={country.id} value={country.id}>
                                                        {country.name}
                                                    </option>
                                                ))
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">State</RBFORM.Label>
                                        <Field
                                            name="state"
                                            as="select"
                                            placeholder="State"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleStateChange(e, setFieldValue)}
                                            disabled={props?.siteInfo}
                                        >
                                            <option>Select State</option>
                                            {filteredStateList?.length > 0 && (
                                                filteredStateList.filter((state: any) => state.id !== "0" && state.id !== 0).map((state: any) => (
                                                    <option key={state.id} value={state.id}>
                                                        {state.name}
                                                    </option>
                                                ))
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">City</RBFORM.Label>
                                        <Field
                                            name="city"
                                            as="select"
                                            placeholder="City"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleCityChange(e, setFieldValue)}
                                            disabled={props?.siteInfo}
                                        >
                                            <option>Select City</option>
                                            {filteredCityList?.length > 0 && (
                                                filteredCityList.filter((city: any) => city.id !== "0" && city.id !== 0).map((city: any) => (
                                                    <option key={city.id} value={city.id}>
                                                        {city.name}
                                                    </option>
                                                ))
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Postal Code</RBFORM.Label>
                                        <Field
                                            name="postalcode"
                                            type="text"
                                            placeholder="Enter Postal Code"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: props?.siteInfo,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Phone Number</RBFORM.Label>
                                        <Field
                                            name="number"
                                            type="text"
                                            placeholder="Phone Number"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: props?.siteInfo,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Mobile Number</RBFORM.Label>
                                        <PhoneInput
                                            specialLabel=""
                                            dropdownClass="user-phone-input-dropdown"
                                            containerClass="user-phone-input-container"
                                            inputClass={`modalForm-input user-phone-input ${errors.mobile && touched.mobile ? "errors" : ""
                                                }`}
                                            inputStyle={{
                                                boxShadow: 'none',
                                                color: "#A5A8A9",
                                                border: errors.mobile && touched.mobile ? "1px solid red" : "1px solid #313838",
                                                width: "100%",
                                                height: "40px",
                                                backgroundColor: "#192529",
                                            }}
                                            value={values.mobile}
                                            onChange={(number) => {setFieldValue("mobile", number); validateMobileNumber(number, "site");}}
                                            onBlur={() => setFieldTouched("mobile", true)}
                                            disabled={props?.siteInfo}
                                            enableLongNumbers={true}
                                        />
                                        {siteMobileNumber && (
                                            <div className="error-message" style={{ color: "#f44336" }}>{siteMobileNumber}</div>
                                        )}
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12 }}></Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Timezone</RBFORM.Label>
                                        <Field
                                            name="timezone"
                                            as="select"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleTimeZoneChange(e, setFieldValue)}
                                            disabled={props?.siteInfo}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <option disabled>Select</option>
                                            {timezoneList.map((tz) => (
                                                <option key={tz.value} value={tz.value}>
                                                    {tz.label}
                                                </option>
                                            ))}

                                        </Field>
                                    </RBFORM.Group>
                                </Grid>

                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span>
                                        {/* <img src={noteIcon} style={{ width: "20px", height: "20px" }} /> */}
                                        <NoteIcon />
                                    </span>
                                    <span
                                        className="label"
                                        style={{ marginLeft: "8px", marginTop: "1.5px", fontSize: "14px", fontWeight: "400" }}
                                    >
                                        Note: If the timezone is not set at the site level, it will default to the customer’s timezone. If the customer’s timezone is also not set, UTC time will be set as default
                                    </span>
                                </div>

                            </Grid>
                        </Row>

                        <Row className="mb-3">
                            <Grid container className="titleTagIo" spacing={3}>
                                Register Site Admin (Optional)
                            </Grid>
                        </Row>

                        <Row className="mb-3" style={{ paddingBottom: "100px" }}>
                            <Grid container rowSpacing={0} columnSpacing={3}>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Site / Device Admin Name</RBFORM.Label>
                                        <Field
                                            name="siteadminname"
                                            type="text"
                                            placeholder="Enter Site / Device Admin Name"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: props?.siteInfo,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 4 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Email ID</RBFORM.Label>
                                        <Field
                                            name="siteadminemail"
                                            type="text"
                                            placeholder="Enter Email ID"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: props?.siteInfo,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 4 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Mobile Number</RBFORM.Label>
                                        <PhoneInput
                                            specialLabel=""
                                            dropdownClass="user-phone-input-dropdown"
                                            containerClass="user-phone-input-container"
                                            inputClass={`modalForm-input user-phone-input ${errors.siteadminmobile && touched.siteadminmobile ? "errors" : ""
                                                }`}
                                            inputStyle={{
                                                boxShadow: 'none',
                                                color: "#A5A8A9",
                                                border: errors.siteadminmobile && touched.siteadminmobile ? "1px solid red" : "1px solid #313838",
                                                width: "100%",
                                                height: "40px",
                                                backgroundColor: "#192529",
                                            }}
                                            value={values.siteadminmobile}
                                            onChange={(number) => {setFieldValue("siteadminmobile", number); validateMobileNumber(number, "admin");}}
                                            onBlur={() => setFieldTouched("siteadminmobile", true)}
                                            disabled={props?.siteInfo}
                                            enableLongNumbers={true}
                                        />
                                        {adminMobileNumber && (
                                            <div className="error-message" style={{ color: "#f44336" }}>{adminMobileNumber}</div>
                                        )}
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <RBFORM.Group className="UploadFld">
                                        <RBFORM.Label className="label">Upload Admin Photo</RBFORM.Label>
                                        {props?.siteInfo &&
                                            <Box
                                                className="UploadIcon1" style={{ width: '100%', height: '120px', border: '1px dashed #5A5F60', borderRadius: '8px', background: '#192529', textAlign: 'center', verticalAlign: 'middle' }}>
                                                {adminPhotoFile && <img src={adminPhotoFile} style={{ height: '100%', width: 'auto', float: 'left' }} />}
                                            </Box>
                                        }
                                        {!props?.siteInfo &&
                                            <>
                                                <input
                                                    name="adminprofileimage"
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png,.gif"
                                                    className="inputC UploadIn"
                                                    /* onChange={(e: any) => {
                                                        setFieldValue("adminprofileimage", e.currentTarget.files[0]);
                                                        previewImage(e, "adminprofileimage");
                                                    }} */
                                                    onChange={(e: any) => {
                                                        handleImageChange(e, "adminprofileimage", setFieldValue, setFieldTouched);
                                                    }}
                                                    id='file'
                                                    ref={adminInputFile}
                                                    style={{ display: 'none' }}
                                                />
                                                <Box
                                                    className="UploadIcon1"
                                                    style={{ width: '100%', height: '120px', border: '1px dashed #5A5F60', borderRadius: '8px', background: '#192529', textAlign: 'center', verticalAlign: 'middle' }}>
                                                    {adminPhotoFile &&
                                                        <>
                                                            <div className="" style={{ display: "flex", height: "100%", position: "relative" }}>
                                                                <img src={adminPhotoFile} style={{ height: '100%', width: 'auto', float: 'left' }} />
                                                                <img src={DeleteIcon} style={{ width: "18px", height: "18px", position: "relative", top: "5px", left: "-20px", cursor: "pointer" }} onClick={(e: any) => removePhoto("adminprofileimage", setFieldValue)} />
                                                            </div>
                                                        </>
                                                    }
                                                    <Box className="UploadIcon" style={{ top: "80px", cursor: 'pointer' }} onClick={() => handleInputFile()}>
                                                        {/* <img src={UploadIn} alt="" width={24} height={24} /> */}
                                                        <IconUpload stroke={1.8} color="#17B2EB" style={{width:"24px", height:"24px"}}/>
                                                         Upload Logo
                                                    </Box>
                                                </Box>
                                            </>
                                        }
                                        {/* {errors.adminprofileimage && touched.adminprofileimage && (
                                            <div style={{ color: "#d32f2f", fontSize: "0.75rem" }}>Admin logo is required!</div>
                                        )} */}
                                        {profileImageError 
                                        // && touched.adminprofileimage 
                                        && (
                                            <div style={{ color: "#f44336", fontSize: "0.75rem" }}>{profileImageError}</div>
                                        )}
                                    </RBFORM.Group>
                                </Grid>

                                <Field
                                    name="enterpriseid"
                                    type="hidden"
                                    component={TextField}
                                    className="inputC"
                                    value={enterpriseId}
                                />
                            </Grid>
                        </Row>


                        <Stack className="fStacky" direction="row" spacing={2} justifyContent="flex-end"
                            sx={{
                                backgroundColor: '#03171F',
                                boxShadow: '-4px -4px 20px #91959621', borderTop: '1px solid #5A5F60', padding: 2,
                            }}>
                            <Button onClick={() => props.setActiveStep(0)} variant="outlined" sx={{ color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#00bcd4', border: '0', fontSize: '14px', fontWidth: '500', }}>
                                Previous
                            </Button>
                            <Button onClick={(e) => handleCancel(e)} variant="outlined" sx={{ marginRight: 'auto !important', color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                ref={saveexitFormBtn}
                                onClick={() => setFieldValue("submitButtonType", "save&exit")}
                                variant="outlined"
                                sx={{ color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}
                            >
                                Save & Exit
                            </Button>
                            {/* <Button variant="contained" sx={{ color: '#1F2F34', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', background: '#17B2EB', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                                Next
                            </Button> */}
                            <Button
                                disabled={isSubmitting}
                                type="submit"
                                variant="contained"
                                color="primary"
                                startIcon={isSubmitting ? <CircularProgress size="0.9rem" /> : undefined}
                                className="btnBlue"
                                sx={{
                                    color: '#1F2F34', height: '41px', lineHeight: '41px',
                                    borderColor: '#0B4A62', background: '#17B2EB !important',
                                    borderRadius: '25px', fontSize: '14px', fontWidth: '500',
                                }}
                                onClick={() => setFieldValue("submitButtonType", "next")}
                            >
                                {isSubmitting ? "Creating..." : "Next"}
                            </Button>
                        </Stack>
                    </Form>

                    {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}

                    <AlertDialogs
                        open={open}
                        setOpen={setOpen}
                        getConfirmResponse={getConfirmResponse}
                        title="Confirm Cancel"
                        message="Are you sure want to cancel registering the customer.<br/>Information if any entered will not be saved.<br/>To save the informtaion click Save & Exit"
                        button1="Save & Exit"
                        button2="Yes, Cancel"
                    />
                </React.Fragment>
            )}
        </Formik>
    );
}

// DynamicCoPIRBFORM.propTypes = CoPiValuePropTypes;